(function () {
  "use strict";
  var CFG = window.AIKA || {};

  function toast(msg) {
    var t = document.getElementById("toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("on");
    clearTimeout(toast.t);
    toast.t = setTimeout(function () { t.classList.remove("on"); }, 2600);
  }

  /* ---- bundle / offres ---- */
  function initProduct(root) {
    var form = root.querySelector("form.pform");
    if (!form) return;
    var idInput = form.querySelector("[data-id-input]");
    var qtyInput = form.querySelector("[data-qty-input]");
    var btn = form.querySelector("#atc");
    var label = btn ? btn.getAttribute("data-label") : "";
    var txt = btn ? btn.querySelector("[data-atc-text]") : null;
    var err = form.querySelector("[data-atc-err]");
    var offers = [].slice.call(root.querySelectorAll("[data-offer]"));
    var sticky = document.getElementById("sticky");
    var gift = "";

    function pick(o) {
      offers.forEach(function (x) { x.setAttribute("aria-checked", String(x === o)); });
      if (idInput) idInput.value = o.getAttribute("data-variant");
      if (qtyInput) qtyInput.value = o.getAttribute("data-qty") || "1";
      gift = o.getAttribute("data-gift") || "";
      var sold = o.hasAttribute("data-soldout");
      if (btn) btn.disabled = sold;
      if (txt) txt.innerHTML = sold ? "Épuisé" : escapeHTML(label) + " <small>· " + escapeHTML(o.getAttribute("data-price")) + "</small>";
      if (sticky) {
        var st = sticky.querySelector("[data-sticky-title]"), sp = sticky.querySelector("[data-sticky-price]");
        if (st) st.textContent = o.getAttribute("data-title");
        if (sp) sp.textContent = o.getAttribute("data-price");
      }
    }
    offers.forEach(function (o) {
      o.addEventListener("click", function () { pick(o); });
      o.addEventListener("keydown", function (e) {
        var i = offers.indexOf(o), n = null;
        if (e.key === "ArrowDown" || e.key === "ArrowRight") n = offers[(i + 1) % offers.length];
        if (e.key === "ArrowUp" || e.key === "ArrowLeft") n = offers[(i - 1 + offers.length) % offers.length];
        if (n) { e.preventDefault(); pick(n); n.focus(); }
      });
    });
    var start = offers.filter(function (x) { return x.getAttribute("aria-checked") === "true"; })[0] || offers[0];
    if (start) pick(start);

    var select = form.querySelector("select[data-id-input]");
    if (select && txt) select.addEventListener("change", function () {
      var opt = select.options[select.selectedIndex];
      txt.innerHTML = escapeHTML(label) + " <small>· " + escapeHTML(opt.getAttribute("data-price")) + "</small>";
    });

    form.addEventListener("submit", function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (err) err.hidden = true;
      var items = [{ id: Number(idInput.value), quantity: Number(qtyInput ? qtyInput.value : 1) || 1 }];
      if (gift) items.push({ id: Number(gift), quantity: 1 });
      [].forEach.call(root.querySelectorAll("[data-addon]:checked"), function (c) { items.push({ id: Number(c.getAttribute("data-addon")), quantity: 1 }); });
      btn.setAttribute("aria-busy", "true");
      fetch((CFG.cartAddUrl || "/cart/add") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.removeAttribute("aria-busy");
          if (!res.ok) {
            if (err) { err.textContent = res.j.description || res.j.message || "Ce produit n'a pas pu être ajouté. Réessayez."; err.hidden = false; }
            return;
          }
          if (CFG.afterAdd === "checkout") { window.location.href = (CFG.root || "/").replace(/\/$/, "") + "/checkout"; return; }
          if (CFG.afterAdd === "cart") { window.location.href = CFG.cartUrl || "/cart"; return; }
          updateCount();
          toast("Ajouté au panier");
        })
        .catch(function () {
          btn.removeAttribute("aria-busy");
          form.submit();
        });
    });

    /* galerie */
    var main = root.querySelector("#gmain");
    [].forEach.call(root.querySelectorAll("[data-g]"), function (t) {
      t.addEventListener("click", function () {
        if (!main) return;
        main.style.opacity = ".3";
        setTimeout(function () { main.removeAttribute("srcset"); main.src = t.getAttribute("data-g"); main.style.opacity = "1"; }, 150);
        [].forEach.call(root.querySelectorAll("[data-g]"), function (x) { x.setAttribute("aria-pressed", String(x === t)); });
      });
    });

    var stickyAdd = document.querySelector("[data-sticky-add]");
    if (stickyAdd) stickyAdd.addEventListener("click", function () {
      if (btn && btn.disabled) { btn.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
      if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
    });

    /* livraison estimée */
    var eta = root.querySelector("[data-eta]");
    if (eta) {
      var mn = Number(eta.getAttribute("data-min")) || 3, mx = Number(eta.getAttribute("data-max")) || 6, co = Number(eta.getAttribute("data-cutoff")) || 0;
      var addBiz = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
      var start = new Date();
      if (co && start.getHours() >= co) start.setDate(start.getDate() + 1);
      var f = function (d) { return d.toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" }); };
      var t = eta.querySelector("[data-eta-text]");
      if (t) t.innerHTML = "Commandez aujourd'hui, livraison estimée entre le <b>" + f(addBiz(start, mn)) + "</b> et le <b>" + f(addBiz(start, mx)) + "</b>";
    }

    /* barre collante */
    if (sticky && btn && "IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        sticky.classList.toggle("on", !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(btn);
    }
  }

  function updateCount() {
    fetch((CFG.cartUrl || "/cart") + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var el = document.getElementById("cartCount");
        if (el) { el.textContent = c.item_count; el.hidden = !c.item_count; }
      }).catch(function () {});
  }

  function escapeHTML(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---- avis : voir plus + photo en grand ---- */
  function initReviews(root) {
    [].forEach.call(root.querySelectorAll("[data-reviews]"), function (list) {
      var limit = Number(list.getAttribute("data-limit")) || 9;
      var cards = [].slice.call(list.children);
      var wrap = list.parentNode;
      var more = wrap.querySelector("[data-more-reviews]");
      var design = window.Shopify && window.Shopify.designMode;
      if (!design) cards.forEach(function (c, i) { if (i >= limit) c.hidden = true; });
      if (more) {
        if (design) more.parentNode.remove();
        else more.addEventListener("click", function () {
          cards.forEach(function (c) { c.hidden = false; });
          more.parentNode.remove();
        });
      }
    });
  }
  document.addEventListener("click", function (e) {
    var lb = e.target.closest && e.target.closest("[data-lb]");
    if (!lb) return;
    var d = document.createElement("div");
    d.className = "lb";
    d.setAttribute("role", "dialog");
    d.setAttribute("aria-label", "Photo cliente");
    d.innerHTML = '<img src="' + escapeHTML(lb.getAttribute("data-lb")) + '" alt="Photo cliente"><button type="button" aria-label="Fermer">✕</button>';
    d.addEventListener("click", function () { d.remove(); lb.focus(); });
    document.body.appendChild(d);
    d.querySelector("button").focus();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { var l = document.querySelector(".lb"); if (l) l.remove(); }
  });

  /* ---- animations ---- */
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var design = window.Shopify && window.Shopify.designMode;
  function initReveal(root) {
    var els = [].slice.call(root.querySelectorAll(".rv"));
    [".steps", ".fgrid", ".stats", ".revs", ".ugcv", ".ugc", ".trust__in"].forEach(function (sel) {
      [].forEach.call(root.querySelectorAll(sel), function (g) {
        [].forEach.call(g.children, function (c, i) { c.style.setProperty("--rd", Math.min(i, 6) * 90 + "ms"); });
      });
    });
    if (!document.documentElement.classList.contains("anim") || reduce || design || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add("in"); }); }, 4000);
  }

  function initCounters(root) {
    if (reduce || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, txt = el.getAttribute("data-final"), m = /^(\D*)(\d+(?:[.,]\d+)?)(.*)$/.exec(txt);
        if (!m) return;
        var target = parseFloat(m[2].replace(",", ".")), dec = (m[2].split(/[.,]/)[1] || "").length, sep = m[2].indexOf(",") > -1 ? "," : ".", t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / 1400), v = target * (1 - Math.pow(1 - k, 3));
          el.textContent = m[1] + v.toFixed(dec).replace(".", sep) + m[3];
          if (k < 1) requestAnimationFrame(step); else el.textContent = txt;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    [].forEach.call(root.querySelectorAll(".stat b"), function (b) { b.setAttribute("data-final", b.textContent.trim()); io.observe(b); });
  }

  function initParallax() {
    if (reduce || !document.documentElement.classList.contains("anim")) return;
    var img = document.querySelector(".hero__m>img, .hero__m picture img");
    var head = document.querySelector(".head");
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (img && y < 900) img.style.setProperty("--py", (y * 0.12).toFixed(1) + "px");
        if (head) head.classList.toggle("is-scrolled", y > 10);
        ticking = false;
      });
    }, { passive: true });
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest(".atc");
    if (!b || reduce) return;
    var r = b.getBoundingClientRect(), s = Math.max(r.width, r.height), d = document.createElement("span");
    d.className = "rip"; d.style.width = d.style.height = s + "px";
    d.style.left = (e.clientX - r.left - s / 2) + "px"; d.style.top = (e.clientY - r.top - s / 2) + "px";
    b.appendChild(d); setTimeout(function () { d.remove(); }, 650);
  });

  /* ---- compte à rebours Black Friday ---- */
  function initCountdowns(root) {
    var cds = [].slice.call(root.querySelectorAll("[data-countdown]"));
    if (!cds.length) return;
    function pad(n) { return (n < 10 ? "0" : "") + n; }
    function tick() {
      var now = Date.now();
      cds.forEach(function (c) {
        var end = Date.parse(c.getAttribute("data-countdown"));
        if (isNaN(end)) { c.hidden = true; return; }
        var ms = end - now;
        if (ms <= 0) {
          if (!c.classList.contains("is-ended")) {
            c.classList.add("is-ended");
            var msg = c.getAttribute("data-ended");
            if (msg) { var p = document.createElement("span"); p.className = "cd-ended"; p.textContent = msg; c.parentNode.insertBefore(p, c.nextSibling); }
          }
          return;
        }
        var t = Math.floor(ms / 1000);
        var q = function (k) { return c.querySelector("[data-" + k + "]"); };
        q("d").textContent = pad(Math.floor(t / 86400));
        q("h").textContent = pad(Math.floor(t % 86400 / 3600));
        q("m").textContent = pad(Math.floor(t % 3600 / 60));
        q("s").textContent = pad(t % 60);
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---- vidéos UGC : lecture auto à l'écran, son au toucher ---- */
  function initVideos(root) {
    var vids = [].slice.call(root.querySelectorAll(".ugcv__i video"));
    vids.forEach(function (v) { v.muted = true; v.setAttribute("playsinline", ""); v.loop = true; });
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target, f = v.closest(".ugcv__i");
          if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); if (f) f.classList.add("is-playing"); }
          else { v.pause(); if (f) f.classList.remove("is-playing"); }
        });
      }, { threshold: 0.4 });
      vids.forEach(function (v) { io.observe(v); });
    }
    [].forEach.call(root.querySelectorAll("[data-sound]"), function (b) {
      var f = b.closest(".ugcv__i"), v = f && f.querySelector("video");
      if (!v) { b.hidden = true; return; }
      var on = b.innerHTML, off = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"/></svg>';
      b.addEventListener("click", function () {
        var unmute = v.muted;
        vids.forEach(function (o) { o.muted = true; });
        [].forEach.call(root.querySelectorAll("[data-sound]"), function (x) { x.innerHTML = on; x.setAttribute("aria-label", "Activer le son"); });
        v.muted = !unmute;
        if (unmute) { v.play(); b.innerHTML = off; b.setAttribute("aria-label", "Couper le son"); }
      });
    });
  }

  function initBA(root) {
    [].forEach.call(root.querySelectorAll("[data-ba]"), function (b) {
      var r = b.querySelector("input");
      if (!r) return;
      function set() { b.style.setProperty("--pos", r.value + "%"); }
      r.addEventListener("input", set); set();
    });
  }

  function init(root) {
    initBA(root);
    initCountdowns(root);
    initVideos(root);
    initCounters(root);
    [].forEach.call(root.querySelectorAll("[data-product-section]"), function (s) { initProduct(s); });
    initReviews(root);
    initReveal(root);
  }
  init(document);
  initParallax();

  /* éditeur de thème Shopify : réinitialiser une section rechargée */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
